import { Icon } from "@/components/Icons";
import { Button, Modal } from "@arco-design/web-react";
import React, { useCallback } from "react";
import "./index.scss";
import { clientWindow } from "@/utils/dom";
import { base64Encode } from "@/utils/url";

interface LoginModalProps {
  visible: boolean;
  onCancel: () => void;
}

const LoginModal: React.FC<LoginModalProps> = (props) => {
  const { visible, onCancel } = props;

  const goToLogin = useCallback(() => {
    const location = clientWindow?.location;
    if (location) {
      const { href } = location;
      clientWindow?.open(`/login?redirect_url=${base64Encode(href)}`);
    }
    onCancel();
  }, [onCancel]);

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      autoFocus={false}
      focusLock={true}
      className={"yf-login-modal"}
      footer={null}
      closeIcon={<Icon.Close width={30} height={30} />}
    >
      <h2 className="yf-login-title">You are currently not logged in</h2>
      <div className="yf-login-actions">
        <Button size={"large"} className={"yf-login-btn"} onClick={goToLogin}>
          Login
        </Button>
      </div>
    </Modal>
  );
};

export default LoginModal;
